import { useEffect, useRef, useState } from "react";
import { InputText } from "primereact/inputtext";
import { IconField } from "primereact/iconfield";
import { InputIcon } from "primereact/inputicon";

import { inputSearch } from "_constants";
import { useAppDispatch, useAppSelector } from "store/store";
import { setFilterAnswers } from "store/slicer/GestioneSaveAnswerSlice";

export const InputSearchResponseChat = () => {
  const dispatch = useAppDispatch();
  const inputRef = useRef<HTMLInputElement>(null);
  const [value, setValue] = useState("");
  const loaded = useAppSelector(
    (state) => state.gestioneSaveAnswerSlice.loaded
  );
  
  
  useEffect(() => {
    if (!loaded) {
      setValue("");
    }
  }, [loaded]);

  const handleChange = (value: string) => {
    setValue(value);
    dispatch(setFilterAnswers(value));
  };

  return (
    <IconField iconPosition="left">
      <InputIcon className="cta pi pi-search"></InputIcon>
      <InputText
        value={value}
        ref={inputRef}
        v-model="value1"
        placeholder={inputSearch}
        onChange={(e) => {
          handleChange(e.target.value);
        }}
        className="width-100"
      />
    </IconField>
  );
};
